import React, { useContext } from "react";
import { IoCloseCircle } from "react-icons/io5";
import OrderPage from "../../pages/OrderPage";
import BottomPopup from "./BottomPopup";
import PopupHeader from "./PopupHeader";
import CartContext from "../../context/CartContext";

const OrderPopup = ({ onClose, onGoBack }) => {
  const cartCtx = useContext(CartContext);

  return (
    <BottomPopup>
      <div className="order-popup">
        <PopupHeader
          title="Your Orders"
          showBackButton={true}
          onGoBack={onGoBack}
          onClose={onClose}
        />
        <OrderPage onClose={onClose} />
      </div>
    </BottomPopup>
  );
};

export default OrderPopup;